import React from "react";
import styled from "styled-components";
import { DisplaySmall, spacing, palette, color } from "@conserveit/blocks";

const Container = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: ${spacing.ultraLoose};
  grid-row-gap: ${spacing.ultraLoose};
  padding: ${spacing.loose};
  border-bottom: 1px solid ${color.theme.divider.solid};

  &:last-of-type {
    border-bottom: none;
  }
`;

const Controls = styled.div`
  grid-column-end: span 2;
`;

// TODO: this is ick, our paragraphs are completely reset outside components
const Subtitle = styled.div`
  color: ${palette.neutral8};

  p {
    margin-bottom: ${spacing.snug};
  }
`;
interface Props {
  heading: string;
  description?: string | JSX.Element;
  children: any;
}
export const FormFieldGroup: React.FC<Props> = ({
  heading,
  description = "",
  children,
}) => (
  <Container>
    <div>
      <DisplaySmall>{heading}</DisplaySmall>
      {description !== "" && (
        // See definition of <Subtitle /> as to why this is
        <Subtitle as={typeof description === "string" ? "p" : "div"}>
          {description}
        </Subtitle>
      )}
    </div>
    <Controls>{children}</Controls>
  </Container>
);
